import { PencilIcon, TrashIcon } from "@vericus/cadmus-icons";
import { ControlButton, DropdownMenu, vars } from "@vericus/cadmus-ui";

import { show } from "@ebay/nice-modal-react";
import { Row } from "@tanstack/table-core";

import { IssueType, ProjectIssueInput } from "@/generated/graphql";

import { getActiveMembers } from "../../../group/utils";
import { useUpdateProjectIssue } from "../../hooks/use-update-project-issue";
import { ProjectIssueWithChildren } from "../../types";
import { DeleteIssueModal } from "../delete-confirmation-modal";
import { IssueFormModal } from "../issue-form";
import { useProjectManagementTableContext } from "../table";

export const IssueMenu = ({ row }: { row: Row<ProjectIssueWithChildren> }) => {
  const { id: issueId, groupId, parentId } = row.original;

  const { table, group, isShowTasksOnly, assessmentDueDate } =
    useProjectManagementTableContext();

  const updateProjectIssue = useUpdateProjectIssue(groupId);

  const milestoneIssues = table
    .getCoreRowModel()
    .rows.map((r) => r.original)
    .filter((row) => row.type === IssueType.Milestone && row.parentId === null);

  const currentIssueParent = table
    .getCoreRowModel()
    .rows.map((r) => r.original)
    .find((r) => r.id === parentId);

  const onDeleteClick = () => {
    const issueToDelete: ProjectIssueInput[] = [
      {
        id: issueId,
        deleted: true,
      } as ProjectIssueInput,
    ];

    show(DeleteIssueModal, {
      issue: row.original,
      onConfirmDelete: () => updateProjectIssue(issueToDelete),
      hasChildren: row.original.children.length > 0,
    });
  };

  const onEditClick = () => {
    show(IssueFormModal, {
      currentIssue: row.original,
      currentIssueParent,
      onSaveIssue: updateProjectIssue,
      memberOptions: getActiveMembers(group).map((m) => {
        return { value: m.id, label: m.name };
      }),
      milestoneOptions: milestoneIssues.map((milestone) => {
        return { value: milestone.id, text: milestone.title };
      }),
      milestoneOptionsEnabled: !isShowTasksOnly,
      assessmentDueDate: assessmentDueDate,
      table,
    });
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <ControlButton
          iconName="More"
          style={{ border: `1px solid ${vars.colors.navy200}` }}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Item
          icon={<PencilIcon label="Edit task" size={20} />}
          content="Edit"
          onClick={() => onEditClick()}
        />
        <DropdownMenu.Item
          icon={<TrashIcon label="Delete task" size={20} />}
          content="Delete"
          onClick={() => onDeleteClick()}
        />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
